import React from 'react'
import PropTypes from 'prop-types'

import './styles.scss'

const ArticleComponent = ({ title, content, variantColor }) => (
  <div className="article">
    <h3 className="article__title">{title}</h3>
    <div
      className={`article__content article__content--${variantColor}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  </div>
)

ArticleComponent.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  variantColor: PropTypes.string,
}

ArticleComponent.defaultProps = {
  variantColor: '',
}

export default ArticleComponent
